import { AgentData } from 'interfaces/AgentData';

export const enum AgentActionType {
    ReceiveAgent = 'AGENTS/RECEIVE_AGENT',
    ReceiveAgents = 'AGENTS/RECEIVE_AGENTS',
}

export type ReceiveAgentAction = ReturnType<typeof receiveAgent>;
export const receiveAgent = (agent: AgentData) => ({
    type: AgentActionType.ReceiveAgent,
    payload: agent,
});

export type ReceiveAgentsAction = ReturnType<typeof receiveAgents>;
export const receiveAgents = (agents: { [agentId: string]: AgentData }) => ({
    type: AgentActionType.ReceiveAgents,
    payload: agents,
});
